import { Component, AfterViewInit, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { Observable, throwError } from 'rxjs';
import { map, startWith, catchError } from 'rxjs/operators';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { AuthenticationService } from '../../core/services/authentication.service';


@Component({
  selector: 'app-bulkmsg',
  templateUrl: './bulkmsg.component.html',
  styleUrls: ['./bulkmsg.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class BulkmsgComponent implements AfterViewInit{
  @Output() public Emergency = new EventEmitter();
  maintenance:boolean = false;
  user:any;
  message:string;
  bulks:any;
  bulk:{id:0, user:any, message:'', execute:true, notify:true, count:0, orders:[], file:any, users:any}={id:0, user:null, message:'', execute:true, notify:true, count:0, orders:[], file:{}, users:{}};

  constructor(private auth:AuthenticationService, private spinner: NgxSpinnerService, private _snackBar: MatSnackBar){
    this.bulkOrders();
  }

  ngAfterViewInit(){
    this.user = JSON.parse(localStorage.getItem('profile'));
  }

  sendMessage(){
    var blk = this.bulk.file;
    delete(blk.file);
    delete(blk.users);
    this.auth.patchAPI('bulk-msg/'+this.bulk.id+'/', blk).subscribe(result => {
      console.log(result);
    })
  }

  upload(file:any){
    this.spinner.show();
    this.auth.postForm('bulk-msg/',[{'file':file.target.files[0]},{'user':this.user.id}]).subscribe((result:any)=>{
      if(result['id']>0){
        this.spinner.hide();
        this._snackBar.open("Data Uploaded Successfully",'', {duration: 5000, panelClass: ['successSnackbar']});
      }
    })
  }

  bulkOrders(){
    this.auth.getAPI('bulk-msg/?limit=20')
      .pipe(catchError(error => {
        if (error.status == 503) {
          this.Emergency.emit(error.error.error);
          this.spinner.hide();
        }
        return throwError(error);
      }))
      .subscribe(result => {
        console.log(result);
        this.bulks = result['results'];
        this.bulk = result['results'][0];
      })
  }

}
